import {memo} from 'react';

import styled from 'styled-components';

import {FlexCenter, FlexSpace} from '~/shared/theme/FlexLayout';
import {bodyBold, captionBold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import {flipOnLTR} from '~/shared/theme/utils';
import {Coupon} from '~/shared/store/models';

import BasketIcon from './basket.svg?react';
import PriceLabelWithDiscount from './PriceLabelWithDiscount';

const Root = styled(FlexSpace)`
  width: 100%;
  flex-direction: row-reverse;
  align-items: center;
`;

const TotalToChargeAmount = styled.span`
  display: block;
  ${bodyBold}
`;

const TextWithCounterWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
  align-items: center;
`;

const ToMyOrderText = styled.span`
  display: block;
  ${bodyBold}
`;

const CounterWrapper = styled.div`
  position: relative;
  height: 28px;
`;

const StyledBasketIcon = styled(BasketIcon)`
  ${flipOnLTR`
    margin-left: 5px;
  `}
`;

const CounterBadge = styled(FlexCenter)`
  top: 0;
  ${captionBold}
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: ${({theme}) => theme.colors.contentDefault};
  background-color: ${({theme}) => theme.colors.surface};
  border: 2px solid ${({theme}) => theme.colors.backgroundInteractive};
  ${flipOnLTR`
    left: -1px;
  `}
`;

type TotalPriceWithItemsCounterProps = {
  totalToCharge: number;
  totalItemsInCart: number;
  currentCoupon: Coupon | null;
};

const TotalPriceWithItemsCounter = ({totalToCharge, totalItemsInCart, currentCoupon}: TotalPriceWithItemsCounterProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <TotalToChargeAmount>
        <PriceLabelWithDiscount price={totalToCharge} currentCoupon={currentCoupon} bold inline />
      </TotalToChargeAmount>
      <TextWithCounterWrapper>
        <ToMyOrderText>
          {t('to_my_order')}
        </ToMyOrderText>
        <CounterWrapper>
          <StyledBasketIcon />
          <CounterBadge>{totalItemsInCart}</CounterBadge>
        </CounterWrapper>
      </TextWithCounterWrapper>
    </Root>
  );
};

export default memo(TotalPriceWithItemsCounter);
